import { Analytics } from '@mui/icons-material';
import { Typography } from '@mui/material';
import React from 'react'

const NoChartData = () => {
  return (
    <div style={{
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <Analytics style={{fontSize: '72px', color: 'grey'}} />
      <Typography variant="body2" style={{color: 'grey'}}>No data available</Typography>
    </div>
  )
}

export default NoChartData;